import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';

import { Subject } from 'rxjs/Subject';

import { SkyVerticalTabsetService } from './vertical-tabset.service';


export class SkyVerticalTabComponent implements OnInit, OnDestroy {

  
  public active: boolean = false;

  
  public tabHeading: string;

  
  public tabHeaderCount: number;

  
  public disabled: boolean = false;

  
  public get showTabRightArrow() {
    return this._showTabRightArrow && this.tabsetService.isMobile();
  }

  public set showTabRightArrow(value: boolean) {
    this._showTabRightArrow = value;
  }

  public index: number;

  
  public tabContent: ElementRef;

  private _showTabRightArrow: boolean = false;
  private _mobileSubscription = new Subject();

  constructor(
    private tabsetService: SkyVerticalTabsetService,
    private changeRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.tabsetService.switchingMobile
      .subscribe((mobile: boolean) => this.changeRef.detectChanges());

    this.tabsetService.addTab(this);
  }

  public ngOnDestroy() {
    this._mobileSubscription.unsubscribe();
  }

  public tabIndex() {
    if (!this.disabled) {
      return 0;
    } else {
      return -1;
    }
  }

  public activateTab() {
    if (!this.disabled) {
      this.active = true;
      this.tabsetService.activateTab(this);

      this.changeRef.markForCheck();
    }
  }

  public tabDeactivated() {
    this.changeRef.detectChanges();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-vertical-tab',
  template: `<a 
  class="sky-vertical-tab"
  [ngClass]="{
    'sky-vertical-tab-active': active, 
    'sky-vertical-tab-disabled': disabled
  }"
  (click)="activateTab()"
  (keyup.enter)="activateTab()"
  [tabIndex]="tabIndex()"
  [attr.aria-selected]="active"
>
  <div class="sky-vertical-tab-display">
    <div class="sky-vertical-tab-heading">
      <span class="sky-vertical-tab-heading-value">{{ tabHeading }}</span>
      <span 
        class="sky-vertical-tab-count"
        *ngIf="tabHeaderCount || tabHeaderCount === 0">
        ({{ tabHeaderCount }})
      </span>
    </div>

    <i 
      *ngIf="showTabRightArrow"
      class="fa fa-chevron-right sky-vertical-tab-right-arrow"
    >
    </i>
  </div>
</a>

<div #tabContentWrapper>
  <div 
    class="sky-vertical-tab-content-pane"
    [ngClass]="{'sky-vertical-tab-hidden': !active}"
  >
    <ng-content></ng-content>
  <div>
</div>
`,
  styles: [`.sky-vertical-tab {
  cursor: pointer;
  padding: 7px 0 7px 10px;
  margin: 5px 0 5px 10px;
  color: #282b31;
  display: flex;
  text-decoration: none;
}

.sky-vertical-tab:hover {
  background-color: #eeeeef;
}

.sky-vertical-tab:focus {
  outline: thin dotted;
  outline: -webkit-focus-ring-color auto 5px;
}

.sky-vertical-tab:hover .sky-vertical-tab-right-arrow {
  color: #979ba2;
}

.sky-vertical-tab-active {
  background-color: #eeeeef;
  color: #282b31;
  padding-left: 6px;
  border-left: 4px solid #00b4f1;
}

.sky-vertical-tab-hidden {
  display: none;
}

.sky-vertical-tab-display {
  display: flex;
  flex-grow: 1;
}

.sky-vertical-tab-heading {
  flex-grow: 1;
}

.sky-vertical-tab-count {
  margin-left: 5px;
}

.sky-vertical-tab-disabled {
  cursor: not-allowed;
  font-style: italic;
  opacity: 0.8;
  pointer-events: none;
}

.sky-vertical-tab-disabled:hover {
  color: #686c73;
}

.sky-vertical-tab-right-arrow {
  padding: 3px 10px 0 0;
  color: #cdcfd2;
}
`],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyVerticalTabsetService, },
{type: ChangeDetectorRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'active': [{ type: Input },],
'tabHeading': [{ type: Input },],
'tabHeaderCount': [{ type: Input },],
'disabled': [{ type: Input },],
'showTabRightArrow': [{ type: Input },],
'tabContent': [{ type: ViewChild, args: ['tabContentWrapper', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
